import React from 'react';

export default function Footer() {
  return (
    <footer className="footer">
      Made with
      <i className="fa-solid fa-heart" />
      by
      <a href="https://github.com/kedaroo/shark-encrypt">Team SharkEncrypt</a>
    </footer>
  );
}
